




























































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import clientRegisterService from "@/services/ClientRegisterService";
import CookieConsentService from "@/services/CookieConsentService";
import userService from "@/services/UserService";
import {UserRequest} from '@/models/UserRequest';

import {
  AnswerRequest,
  AnswerResponse,
  APIResponse,
  ClientStatus,
  QuestionResponse,
  QuestionTO,
  RegisterRequest,
  RegisterResponse,
  TokenRequest,
  TokenResponse,
} from "@/models";
import VueRecaptcha from "vue-recaptcha";

// NOVOS IMPORTS
import ApiError from "@/models/ApiError";
import ValidationHelper from "@/helpers/ValidationHelper";
import {RefiDigitalEnum} from "@/helpers/refi-digital.enum";
import codeGenMetadata from "@/helpers/register-form";
import Modal from "@/components/Modal.vue";
import {OmniUsuarioEnum} from '@/helpers/omni-usuario.enum';
import {ToastOptions} from "vue-toastification/dist/types/src/types";
import {TYPE} from "vue-toastification/dist/types/src/ts/constants";

@Component({
  components: {
    VueRecaptcha,
    Modal
  },
})
export default class Register extends Vue {
  public EMAIL_REMETENTE: string = process.env.VUE_APP_EMAIL_REMETENTE;
  public token: string = "";
  public question: QuestionTO | null = null;
  public tokenResponse: TokenResponse | null = null;
  public isOpen = false;

  public finishedRegister: boolean = false;
  public hasQuestion: boolean = false;
  public hasAnswer: boolean = false;
  public questionResponse: QuestionResponse | null = null;

  public mothersFirstName: string | null = null;
  public birthdayDay: number | null = null;
  public birthdayYear: number | null = null;
  public answerResponse: AnswerResponse | null = null;

  public acceptTermsAndConditions: boolean = false;
  public cellphone: string = "";
  public email: string = "";
  public confirmEmail: string = "";
  public password: string = "";
  public confirmPassword: string = "";
  public registerResponse: RegisterResponse | null = null;

  public userResponse: RegisterResponse | any = null;
  public emailReSuccessfullySent: boolean = false;
  private _tokenRecaptcha: string = "";

  public isBusy: boolean = false;
  public errorMessage: string = "";
  public countClick: number = 0;
  public termsLink: string = RefiDigitalEnum.USERS_TERMS;
  public cookieConsentService: CookieConsentService = new CookieConsentService(codeGenMetadata)

  public privacyPolicyRoute: any = {
    name: "privacy-policy",
    query: {
      source: "register",
    },
  };

  /// NOVOS METODOS ///
  //public recaptchaSiteKey: string = '6LfaPPoUAAAAADQl1NrjYV7NHXngxCM511OTTxoA';
  public recaptchaSiteKey: string = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  public loginEmAndamento: boolean = false;
  public cpf: string = "";

  public localErrors: ApiError[] = [];

 mounted(){
 }

  public reset() {
    this.cpf = "";
  }

  public validarCpf(cpf: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== "cpf");
    const erro = { property: "cpf", message: "" };

    if (cpf.length === 0) {
      erro.message = "Informe um CPF.";
      this.showMessage(erro.message);
      this.localErrors.push(erro);
      return;
    }

    const v = ValidationHelper.cpf(cpf);
    if (v === false) {
      erro.message = "O CPF informado é inválido.";
      this.showMessage(erro.message, 'error');
      this.localErrors.push(erro);
    }
  }

  public validarCelular(telefone: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== "celular");
    const erro = { property: "celular", message: "O celular informado é inválido." };
    if(!ValidationHelper.cellphone(telefone)) {
      this.showMessage(erro.message, 'error');
      this.localErrors.push(erro);
    }
  }

  public solicitarLogin(e: Event) {
    this.loginEmAndamento = true;

    this.localErrors = [];
    this.validarCpf(this.cpf);

    if (this.localErrors.length) {
      this.loginEmAndamento = false;
      return;
    }

    (this.$refs.recaptcha as VueRecaptcha).reset();
    (this.$refs.recaptcha as VueRecaptcha).execute();
  }

  public mensagemErro(input: string) {
    const errors = this.localErrors.filter((erro) => erro.property === input);
    return errors.length ? errors[0].message : "";
  }

  public possuiErros(input: string) {
    return this.localErrors.find((erro) => erro.property === input);
  }

  public recaptchaValidado(tokenRecaptcha: string) {
    this.loadQuestion(tokenRecaptcha);
  }

  public recaptchaEmailValidado(tokenRecaptcha: string) {
    this.reSendEmail(tokenRecaptcha);
  }

  public solicitarReenvioEmail() {
    (this.$refs.recaptchaEmail as VueRecaptcha).reset();
    (this.$refs.recaptchaEmail as VueRecaptcha).execute();
  }

  /**
   * @param type
   * SUCCESS = "success",
   * ERROR = "error",
   * WARNING = "warning",
   * INFO = "info",
   * DEFAULT = "default"
   */
  public showMessage(message = '', type = 'info') {
    this.$toast.clear();
    const options: (ToastOptions & { type?: TYPE.INFO | undefined } | any) = {
      timeout: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.83,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: "button",
      icon: true,
      rtl: false
    }
    switch (type) {
      case 'success' :  this.$toast.success(message, options); break;
      case 'error' : this.$toast.error(message, options); break;
      case 'warning' : this.$toast.warning(message, options); break;
      case 'info' : this.$toast.info(message, options); break;
    }
  }

  public showErrorMessage(message = '', error: any) {
    if (error.response && error.response.data && error.response.data.omniSpanId) {
      message += `\n\n OmniSpanId: ${error.response.data.omniSpanId}`;
    }    
    this.showMessage(message, 'error');
  }


  public checkStrengthPassword(password: string): boolean {
    const numeros = /([0-9])/;
    const alfabeto = /([a-zA-Z])/;
    const chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
    if (password.length < 8) {
      this.errorMessage = "A senha deve ter no mínimo 8 caracteres.";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
    if (password.match(numeros) && password.match(alfabeto) && password.match(chEspeciais)) {
      return true;
    } else {
      this.errorMessage = "Senha média, insira um caracter especial, pelo menos 1 letra maiúscula ou minúscula e um número!";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
  }

  // FIM NOVOS METODOS ///

  public async loadQuestion(recaptcha: string) {
    (this.$refs.recaptcha as VueRecaptcha).reset();
    this.errorMessage = "";
    this.loginEmAndamento = true;

    let keycloackKey = localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID);
    const tokenRequest = {
      document: this.cpf,
      recaptchaResponse: recaptcha,
      clientId: keycloackKey,
    } as TokenRequest;

    try {
      this.tokenResponse = await clientRegisterService.token(tokenRequest);

      if (
        this.tokenResponse.status === APIResponse.INCORRECT_CAPTCHA_RESPONSE
      ) {
        this.loginEmAndamento = false;
        this.errorMessage = "Erro no CAPTCHA. Tente novamente.";
        this.showMessage(this.errorMessage);
        return;
      } else if (this.tokenResponse.status === APIResponse.CLIENT_NOT_FOUND) {
        this.loginEmAndamento = false;
        this.errorMessage = "Cliente não encontrado.";
        this.$router.push({ name: "register-refi-digital" });
        return;
      } else if (
        this.tokenResponse.status === APIResponse.INSUFFICIENT_CLIENT_DATA
      ) {
        this.loginEmAndamento = false;
        this.errorMessage = "Cliente não encontrado ou dados insuficientes.";
        this.showMessage(this.errorMessage, 'warning');
        this.errorMessage =
            "Ocorreu um erro no seu cadastro. Por favor, entre em contato com nosso atendimento através do ​Whatsapp (11) 93373-5583 ou no e-mail refimais@omni.com.br";
        this.showMessage(this.errorMessage, 'warning');
        return;
      } else if (
        this.tokenResponse.status === APIResponse.INVALID_CLIENT_STATUS
      ) {
        this.loginEmAndamento = false;
        this.errorMessage = this.getInvalidStatusErrorMessage(
          this.tokenResponse
        );
        return;
      } 
      this.token = this.tokenResponse.token;

      this.questionResponse = await clientRegisterService.question(this.token);
      this.question = this.questionResponse.question;
      this.hasQuestion = this.questionResponse.status === APIResponse.SUCCESS;
    } catch (error) {
      if (error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        this.errorMessage = "Esse CPF já possui cadastro no Portal da Omni, digite a senha cadastrada ou clique em esqueci minha senha.";
      } else {
        this.errorMessage = "Ocorreu um erro. Tente novamente mais tarde.";
      }
      this.showErrorMessage(this.errorMessage, error);
      this.loginEmAndamento = false;
    } finally {
      this.loginEmAndamento = false;
    }
  }

  public async sendAnswer() {
    this.loginEmAndamento = true;
    this.errorMessage = "";

    if (!this.birthdayDay || !this.birthdayYear || !this.mothersFirstName) {
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha todos os campos.";
      this.showMessage(this.errorMessage);
      return;
    } else if (this.birthdayYear && this.birthdayYear.toString().length < 4) {
      this.loginEmAndamento = false;
      this.errorMessage = "Campo ano de nascimento deve ter 4 dígitos.";
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    const answerRequest = {
      birthdayDay: this.birthdayDay,
      birthdayYear: this.birthdayYear,
      mothersFirstName: this.mothersFirstName,
    } as AnswerRequest;

    try {
      this.answerResponse = await clientRegisterService.answer(
        answerRequest,
        this.token
      );

      if (this.answerResponse.status === APIResponse.INCORRECT_ANSWER) {
        this.loginEmAndamento = false;
        this.errorMessage = "Dados incorretos.";
        this.showMessage(this.errorMessage, 'error');
        return;
      } else if (this.answerResponse.status === APIResponse.TOKEN_ERROR) {
        this.isBusy = false;
        this.errorMessage =
          "Acesso bloqueado por divergência na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento: 4004 3500 (Capitais e Regiões Metropolitanas) 0800 701 3500 (Demais Regiões). Atendimento de segunda-feira a sábado das 8h às 20h. SAC: 0800 727 0885 - Atendimento para todos os produtos, 24 horas, 7 dias por semana";
        this.showMessage(this.errorMessage, 'error');
        return;
      }

      this.hasAnswer = this.answerResponse.status === APIResponse.SUCCESS;
    } catch (error) {
      this.errorMessage = "Ocorreu um erro. Tente novamente mais tarde.";
      this.showErrorMessage(this.errorMessage, error);
      this.loginEmAndamento = false;
    } finally {
      this.loginEmAndamento = false;
    }
  }

  public async sendRegister() {
    this.loginEmAndamento = true;
    this.errorMessage = "";

    if (!this.acceptTermsAndConditions) {
      this.loginEmAndamento = false;
      this.errorMessage =
        "É necessário concordar com os termos e condições para se cadastrar.";
      this.showMessage(this.errorMessage);
      return;
    }

    if (
      !this.cellphone ||
      !this.email ||
      !this.password ||
      !this.confirmPassword
    ) {
      this.loginEmAndamento = false;
      this.errorMessage = "Prencha todos os campos.";
      this.showMessage(this.errorMessage);
      return;
    }

    if (!this.validEmail()) return;

    this.validarCelular(this.cellphone);

    if (this.password !== this.confirmPassword) {
      this.loginEmAndamento = false;
      this.errorMessage =
        "As senhas não coincidem. Digite sua senha novamente.";
      this.password = "";
      this.confirmPassword = "";
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    if (!this.checkStrengthPassword(this.password)) {
      this.loginEmAndamento = false;
      return;
    }

    if(this.localErrors && this.localErrors.length >= 1){
      this.errorMessage = this.localErrors[0]['message'] as string;
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    const registerRequest = {
      acceptNotifications: true,
      acceptTermsAndConditions: this.acceptTermsAndConditions,
      cellphone: this.cellphone,
      email: this.email,
      password: this.password,
      redirectUri: localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_REDIRECTURI),
      clientId: localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID),
    } as RegisterRequest;

    this.cookieConsentService.uploadConsent();
    try {
      this.registerResponse = await clientRegisterService.register(
        registerRequest,
        this.token
      );
      if (this.registerResponse.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.loginEmAndamento = false;
        this.errorMessage =
          "Não foi possível registrar o usuário pois o e-mail já está em uso.";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      this.finishedRegister = this.registerResponse.status === APIResponse.SUCCESS;
    } catch (error) {
      this.errorMessage = "Não foi possível realizar o cadastro.";
      this.showErrorMessage(this.errorMessage, error);
      this.loginEmAndamento = false;
    } finally {
      this.loginEmAndamento = false;
    }
  }

  public getInvalidStatusErrorMessage(response: any): string {
    let errorMessage = "";
    const [responseMessage]: string[] = response.messages;

    const [_, status] = responseMessage.split(": ");

    switch (status) {
      case ClientStatus.REGISTERED:
        errorMessage = "Esse CPF já possui cadastro no Portal da Omni, digite a senha cadastrada ou clique em esqueci minha senha.";
        break;

      case ClientStatus.BLOCKED:
        errorMessage =
          "Acesso bloqueado por divergência  na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento 08007013500 ou 4004-3500.";
        break;

      default:
        break;
    }

    return errorMessage;
  }

  @Watch('email')
  public watchEmail(data: string) {
    this.email = data.toLowerCase();
  }

  @Watch('confirmEmail')
  public watchConfirmEmail(data: string) {
    this.confirmEmail = data.toLowerCase();
  }

  @Watch("mothersFirstName")
  public watchMothersFirstName(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      (this.$refs.birthdayDayInput as HTMLInputElement).focus();
    }
  }

  @Watch("hasQuestion")
  public watchHasQuestion(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  @Watch("hasAnswer")
  public watchHasAnswer(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  verifyUserTerms() {
    this.openModal();
  }

  public openModal() {
    this.isOpen = true;
  }

  public closeModal() {
    this.isOpen = false;
  }

  public validEmail(): boolean {
    const validEmail = ValidationHelper.email(this.email);
    if (!validEmail) {
      this.loginEmAndamento = false;
      this.errorMessage = "Endereço de e-mail inválido.";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
    if (!this.validConfirmEmail()) return false;
    return true;
  }

  public validConfirmEmail(): boolean {
    const email = ValidationHelper.email(this.confirmEmail);
    if (!email) {
      this.loginEmAndamento = false;
      this.errorMessage = "Endereço de e-mail inválido. (Confirme seu e-mail)";
      this.showMessage(this.errorMessage);
      return false;
    }
    if (this.email != this.confirmEmail) {
      this.errorMessage = "Verifique o e-mail cadastrado, os campos 'E-mail” e “Confirme seu e-mail” devem ser iguais.";
      this.showMessage(this.errorMessage);
      return false;
    }
    return true;
  }

  public async reSendEmail(recaptcha: string) {
    if (!this.validEmail()) return;
    const userRequest = {
      document: this.cpf,
      redirectUri: localStorage.getItem("omni-keycloak-redirectUri"),
      recaptchaResponse: recaptcha,
      clientId:
          localStorage.getItem("omni-keycloak-clientId") === "refi-digital"
              ? "refi-digital"
              : "acerto",
    } as UserRequest;
    try {
      this.userResponse = await userService.resendEmail(userRequest, this.token);
      if (this.userResponse.status === APIResponse.TOKEN_ERROR) {
        this.isBusy = false;
        this.errorMessage =
            "Acesso bloqueado por divergência na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento: 4004 3500 (Capitais e Regiões Metropolitanas) 0800 701 3500 (Demais Regiões). Atendimento de segunda-feira a sábado das 8h às 20h. SAC: 0800 727 0885 - Atendimento para todos os produtos, 24 horas, 7 dias por semana";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      if (this.userResponse.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.loginEmAndamento = false;
        this.errorMessage =
            "Não foi possível registrar o usuário pois o e-mail já está em uso.";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      if(this.userResponse.status === APIResponse.INCORRECT_CAPTCHA_RESPONSE) {
        this.loginEmAndamento = false;
        this.errorMessage = "Erro no CAPTCHA. Tente novamente.";
        this.showMessage(this.errorMessage);
        return;
      }
      if (this.userResponse.status === APIResponse.SUCCESS) {
        // E-mail enviado com sucesso
        this.emailReSuccessfullySent = true;
      }
    } catch (error) {
      this.errorMessage = "Não foi possível enviar o e-mail, Por gentileza entre em contato com nossa Central de Relacionamento.";
      this.showErrorMessage(this.errorMessage, error);
    } finally {
    }
  }

}
